import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  input: {
    opacity: 0,
    display: 'none',
  },
}));
